import { render } from "./CardListView.vue?vue&type=template&id=31ff9a27&scoped=true"
import script from "./CardListView.vue?vue&type=script&lang=js"
export * from "./CardListView.vue?vue&type=script&lang=js"

import "./CardListView.vue?vue&type=style&index=0&id=31ff9a27&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ff9a27"]])

export default __exports__